const SCROLL_LOCK_CLASS = 'hm-scroll-locked'

let lockCount = 0
let savedWindowScrollY = 0
let savedRootScrollTop = 0
let lockedRootEl: HTMLElement | null = null

function getGutterScrollRoot(): HTMLElement | null {
  return document.querySelector('.home-root--gutter-scroll')
}

export function lockBodyScroll(): void {
  if (typeof document === 'undefined') return
  lockCount++
  if (lockCount !== 1) return

  savedWindowScrollY = window.scrollY
  lockedRootEl = getGutterScrollRoot()
  savedRootScrollTop = lockedRootEl?.scrollTop ?? 0

  document.documentElement.classList.add(SCROLL_LOCK_CLASS)
  document.body.classList.add(SCROLL_LOCK_CLASS)
}

export function unlockBodyScroll(): void {
  if (typeof document === 'undefined') return
  if (lockCount <= 0) return
  lockCount--
  if (lockCount !== 0) return

  document.documentElement.classList.remove(SCROLL_LOCK_CLASS)
  document.body.classList.remove(SCROLL_LOCK_CLASS)

  if (lockedRootEl) {
    lockedRootEl.scrollTop = savedRootScrollTop
    lockedRootEl = null
  }

  window.scrollTo(0, savedWindowScrollY)
}
